import Helper from './Helper';

class Glossary {
  constructor() {
    const glossaries = Array.prototype.slice.call(document.querySelectorAll('.js-glossary-trigger'));
    glossaries.forEach(g => {
      let html = atob(g.dataset.key);
      html += `<div class="glossary-tooltip">
                <span class="glossary-tooltip__title">${atob(g.dataset.title)}</span>
                <span class="glossary-tooltip__text">${atob(g.dataset.description)}</span>
              </div>`;
      g.innerHTML = html;
    })
  }
}
export default Glossary;
